// Cockpit brand mark: the Ampersand "&" set inside an olive rounded-square tile.
// Source: ui/public/cockpit-mark.svg (inlined here so React can size it freely).
//
// On dev and stage a coloured bubble (45 percent of the tile height) sits on the tile's bottom-right corner
// (red for dev, yellow for stage); prod has none. The mark itself is the same
// colours everywhere. The environment comes from the hostname (`lib/appEnv.ts`).
//
// Colors are fixed to the brand palette (olive tile + cream glyph) because the
// mark is two-tone. `strokeWidth` is accepted for backwards compatibility but
// not used by this design.

import { ENV_BADGE_COLOR, currentAppEnv, type AppEnv } from '@/lib/appEnv';

type Props = {
  size?: number;
  strokeWidth?: number;
  className?: string;
  title?: string;
  /** Overrides the environment read from the hostname (stories and tests). */
  env?: AppEnv;
};

export function CandyGlyph({
  size = 22,
   
  strokeWidth: _strokeWidth,
  className,
  title,
  env,
}: Props) {
  const resolved = env ?? currentAppEnv();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <rect width="32" height="32" rx="6" fill="#998659" />
      <text
        x="16"
        y="23.5"
        textAnchor="middle"
        fontFamily="'Italiana','Cormorant Garamond',Georgia,serif"
        fontSize="24"
        fontStyle="italic"
        fontWeight="400"
        fill="#FAF5E6"
      >
        &amp;
      </text>
      {resolved !== 'prod' && (
        <circle
          cx="24.4"
          cy="24.4"
          r="6.6"
          fill={ENV_BADGE_COLOR[resolved]}
          stroke="#FAF5E6"
          strokeWidth="1.2"
          data-env-badge={resolved}
        />
      )}
    </svg>
  );
}
